import React from "react";
import autoBind from "react-autobind";
import Slider from "rc-slider";
import _ from "lodash";
import "rc-slider/assets/index.css";
import { FormControl } from "react-bootstrap";
const createSliderWithTooltip = Slider.createSliderWithTooltip;
const SliderWithTooltip = createSliderWithTooltip(Slider); // eslint-disable-line

export default class SliderInput extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
		
		let value = this.getDefaultValue(this.props.value);

		this.state = {
			value: value,
			inputValue: value
		};
	}

	componentWillReceiveProps(nextProps) {
		let value = this.getDefaultValue(nextProps.value);
		if (nextProps.value !== this.props.value) {			
			this.setState({
				value: value,
				inputValue: value
			});
		}
	}

	onChange(e) {
		let value = e;

		this.setState({
			value: value,
			inputValue: value
		});
		if (this.props.onChange) {
			if (e === this.props.emptyValue) {
				this.props.onChange(null);	
			} else {
				this.props.onChange(value);
			}
		}
	}

	onChangeInput(e) {
		let value = e.target.value;

		this.setState({
			inputValue: value
		});
	}


	onBlurInput(e) {
		let value = e.target.value;

		this.setState({
			inputValue: value
		});

		this.onInputSubmit(value);
	}

	onKeyDownInput(e) {
		if (e.keyCode === 13) {
			this.onInputSubmit(this.state.inputValue);			
		}
	}

	onInputSubmit(value) {

		let submitValue;
		let intValue = parseInt(value);

		if (_.isNaN(intValue)) {
			//if we allow empty values, use null, if not, use min
			if (this.props.emptyValue) {
				this.onAfterChange(null);
			} else if (this.props.min) {
				this.onAfterChange(this.props.min);
				this.setState({
					value: this.props.min,
					inputValue: this.props.min
				});
			}
		} else {
			if (intValue < this.props.min) {
				submitValue = this.props.min;
			} else if (intValue > this.props.max) {
				submitValue = this.props.max;
			} else {
				submitValue = intValue;
			}

			this.setState({
				value: submitValue,
				inputValue: submitValue
			});

			this.onAfterChange(submitValue);
		}
	}


	onAfterChange(e) {		
		if (this.props.onAfterChange) {
			if (e === this.props.emptyValue) { 
				this.props.onAfterChange(null);
			} else {
				this.props.onAfterChange(e);
			}			
		}
	}

	onReset() {
		
		let resetValue = this.getDefaultValue(null);

		this.setState({
			value: resetValue,
			inputValue: resetValue
		});

		let resetValueForCallback = resetValue;
		
		if (this.props.emptyValue === resetValueForCallback) {
			resetValueForCallback = null;
		}

		if (this.props.onAfterChange) {
			this.props.onAfterChange(resetValueForCallback);
		}

		if (this.props.onChange) {
			this.props.onChange(resetValueForCallback);
		}		
	}

	getDefaultValue(value) {

		let defaultValue;

		if (!_.isNumber(value)) {
			if (this.props.defaultValue) {
				defaultValue = this.props.defaultValue;
			} else if (this.props.emptyValue) {
				defaultValue = this.props.emptyValue;
			} else {
				defaultValue = this.props.min;
			}
		} else {
			defaultValue = value;
		}

		return defaultValue;
	}

	render() {

		let valueClassName = (this.props.valueClassName) ? this.props.valueClassName : "slider-value";
		let containerClassName = (this.props.containerClassName) ? this.props.containerClassName : "slider-container";


		let displayValue = this.state.value;

		if (this.state.value === this.props.emptyValue && this.props.placeholderDisplayValue) {
			displayValue = this.props.placeholderDisplayValue;
		}

		let valueInput = displayValue;
		if (this.props.showValueInput && this.state.value !== this.props.emptyValue) {
			valueInput = <FormControl onChange={this.onChangeInput} onBlur={this.onBlurInput} onKeyDown={this.onKeyDownInput} type="number" value={this.state.inputValue} style={this.props.valueStyle} min={this.props.min} max={this.props.max}/>;		
		}

		let valueContainer = <div className={valueClassName} style={this.props.valueStyle}>{valueInput}</div>;			
		
		let resetButton;
		if (this.props.showResetButton) {
			resetButton = <button class="slider-reset-button btn btn-default" onClick={this.onReset}>Reset</button>;
		}

		let props = {
			value: this.state.value,
			defaultValue: this.props.defaultValue,
			min: this.props.min,
			max: this.props.max,
			step: this.props.step,
			marks: this.props.marks,
			onChange: this.onChange,
			onAfterChange: this.onAfterChange,
			railStyle: this.props.railStyle,
			trackStyle: this.props.trackStyle,
			handleStyle: this.props.handleStyle
		};

		let component;
		if (this.props.showTooltip) {
			component = <SliderWithTooltip {...props} />;
		} else {
			component = <Slider {...props} />;
		}

		return (
			<div className={containerClassName}>		
				{resetButton}	
				{component}
				{valueContainer}
			</div>
		);
	}
}
